import { useLoginScreenState } from './login_screen_state';

export function sendChatByLoginScreen(message: string) {
  return useLoginScreenState.getState().sendMessage(message);
}
